export const riggingBayTheme = {
    id: 'rigging-bay',
    label: 'Rigging Bay',
    description: 'Operations-floor. Practical contrast, hardware-focused, less neon.',
    paletteMode: 'dark',
    tokens: {
        app: { bg: '#101113', bgElevated: '#17191C' },
        surface: {
            nav: '#101113',
            panel: '#24272B',
            panelAlt: '#343941',
            input: '#191C20',
        },
        border: {
            default: 'rgba(238, 243, 247, 0.14)',
            strong: 'rgba(58, 167, 255, 0.48)',
        },
        text: {
            primary: '#EEF3F7',
            secondary: '#AAB3BD',
            disabled: '#6D7885',
            inverse: '#061016',
        },
        action: {
            primary: '#3AA7FF',
            primaryHover: '#72C1FF',
            secondary: '#FFC247',
        },
        state: {
            success: '#3AA7FF',
            warning: '#FFC247',
            error: '#E53935',
            info: '#6D7885',
        },
        data: {
            seriesA: '#3AA7FF',
            seriesB: '#FFC247',
            seriesC: '#E53935',
            seriesD: '#6D7885',
        },
        effect: {
            glow: 'rgba(58, 167, 255, 0.34)',
            shadow: '0 18px 54px rgba(0, 0, 0, 0.34)',
        },
    },
};
//# sourceMappingURL=rigging-bay.js.map